import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const undoIcon: SvgIconData = {
  viewBox: '2 5.27 28 21.97',
  element: (
    <path d="M16.9 9.88a15.1 15.1 0 0 1 13.03 16.46 1 1 0 0 1-1.83.45 16 16 0 0 0-11.2-6.94v3.6a1 1 0 0 1-1.56.84l-12.9-8.6a1 1 0 0 1 0-1.66l12.9-8.6a1 1 0 0 1 1.55.84z" />
  ),
};
